<!-- contact.component.html -->
<p>contact works!</p>
